// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressToJSON,
    PlaceOfServiceType,
    PlaceOfServiceTypeFromJSON,
    PlaceOfServiceTypeToJSON,
    Registry,
    RegistryFromJSON,
    RegistryToJSON,
    Revision,
    RevisionFromJSON,
    RevisionToJSON,
    Tags,
    TagsFromJSON,
    TagsToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportFacility
 */
export interface SupportFacility extends Tags {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    id?: string;
    /**
     * Facility name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    name: string;
    /**
     * Facility nickname
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    nickname?: string;
    /**
     * Facility description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    description?: string;
    /**
     * The addresses
     * OpenAPI data type: {array}
     * @type {Array<Address>}
     * @memberof SupportFacility
     */
    addresses: Array<Address>;
    /**
     * Facility NPI
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    npi?: string;
    /**
     * Facility EIN
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    ein?: string;
    /**
     * Facility SSN
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    ssn?: string;
    /**
     * Facility institutional revenue code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    revenueCode?: string;
    /**
     * Facility other ID
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    other?: string;
    /**
     * 
     * OpenAPI data type: {PlaceOfServiceType}
     * @type {PlaceOfServiceType}
     * @memberof SupportFacility
     */
    placeOfServiceCode?: PlaceOfServiceType;
    /**
     * 
     * OpenAPI data type: {Registry}
     * @type {Registry}
     * @memberof SupportFacility
     */
    registry?: Registry;
    /**
     * User markable as starred
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportFacility
     */
    starred?: boolean;
    /**
     * Is active
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportFacility
     */
    active?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportFacility
     */
    created?: string;
    /**
     * The revision group
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportFacility
     */
    groupId?: string;
    /**
     * Revisions within the resource group
     * OpenAPI data type: {array}
     * @type {Array<Revision>}
     * @memberof SupportFacility
     */
    revisions?: Array<Revision>;
}

export function SupportFacilityFromJSON(json: any): SupportFacility {
    return {
                'id': !exists(json, 'id') ? undefined : json['id'],
                'name': json['name'],
                'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
                'description': !exists(json, 'description') ? undefined : json['description'],
                'addresses': (json['addresses'] as Array<any>).map(AddressFromJSON),
                'npi': !exists(json, 'npi') ? undefined : json['npi'],
                'ein': !exists(json, 'ein') ? undefined : json['ein'],
                'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
                'revenueCode': !exists(json, 'revenueCode') ? undefined : json['revenueCode'],
                'other': !exists(json, 'other') ? undefined : json['other'],
                'placeOfServiceCode': !exists(json, 'placeOfServiceCode') ? undefined : PlaceOfServiceTypeFromJSON(json['placeOfServiceCode']),
                'registry': !exists(json, 'registry') ? undefined : RegistryFromJSON(json['registry']),
                'starred': !exists(json, 'starred') ? undefined : json['starred'],
                'active': !exists(json, 'active') ? undefined : json['active'],
                'created': !exists(json, 'created') ? undefined : json['created'],
                'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
                'revisions': !exists(json, 'revisions') ? undefined : (json['revisions'] as Array<any>).map(RevisionFromJSON),
        ...TagsFromJSON(json)
    };

}

export function SupportFacilityToForm(value?: SupportFacility): any {
    let jsonVal = SupportFacilityToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportFacilityToJSON(value?: SupportFacility): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'name': cleanupBlankValuesForBackend(value.name),
            'nickname': cleanupBlankValuesForBackend(value.nickname),
            'description': cleanupBlankValuesForBackend(value.description),
            'addresses': (value.addresses as Array<any>).map(AddressToJSON),
            'npi': cleanupBlankValuesForBackend(value.npi),
            'ein': cleanupBlankValuesForBackend(value.ein),
            'ssn': cleanupBlankValuesForBackend(value.ssn),
            'revenueCode': cleanupBlankValuesForBackend(value.revenueCode),
            'other': cleanupBlankValuesForBackend(value.other),
            'placeOfServiceCode': PlaceOfServiceTypeToJSON(value.placeOfServiceCode),
            'registry': RegistryToJSON(value.registry),
            'starred': cleanupBlankValuesForBackend(value.starred),
            'active': cleanupBlankValuesForBackend(value.active),
            'created': cleanupBlankValuesForBackend(value.created),
            'groupId': cleanupBlankValuesForBackend(value.groupId),
            'revisions': (value.revisions === undefined || value.revisions === null) ? undefined  : (value.revisions as Array<any>).map(RevisionToJSON),
            ...TagsToJSON(value)
    };
}


